<ca-clickable-link
  [innerHtml]="
    'QualityManagement::EvaluationResultAgentNotificationMessage'
      | abpLocalization
        : payloadData?.conversationId
        : payloadData?.score.toFixed(1)
        : payloadData?.maxScore.toFixed(1)
  "
  (linkClicked)="onLinkClicked()"></ca-clickable-link>
